export default "__VITE_ASSET__CLVXbv1x__"